import React, {useEffect, useState} from "react"

// styling and images
import "./Warning.scss"
import {Warning as WarningIcon} from "../../images/js"

function Warning({text}) {
  const [lines, setLines] = useState([])

  // text prop changed
  useEffect(() => {
    if(Array.isArray(text)) {
      setLines(text)
    }
    else {
      setLines([text])
    }
  }, [text])

  // render
  let paragraphs = lines.map((line, index) => <p key={index}>{line}</p>)
  return (
    <div className="c-warning">
      <div className="icon"><WarningIcon /></div>
      <div className="text">{paragraphs}</div>
    </div>
  )
}

export default Warning